import GalleryImage from '../../components/GalleryImage';
import PageHeader from '../../components/PageHeader';
import { useGallery } from '../../misc/lib/gallery';
import './GalleryPage.scss';

const GalleryPage = () => {
  const gallery = useGallery();

  return (
    <div className="gallerypage-container">
      <PageHeader text="Galéria" />
      <div className="gallerypage-img-list">
        { gallery.map((img, i) => (
          <GalleryImage key={ i } { ...img } />
        )) }
      </div>
    </div>
  );
};

export default GalleryPage;
